module.exports = __webpack_public_path__ + "img/50n.29b38bbd.png";